<template>
  <v-select hide-no-data v-bind="$props" :items="items" :menu-props="menuProperties">
    <template v-slot:item="{ item }">
      <v-list-item style="padding: 0">
        <v-color-picker
          hide-inputs
          hide-sliders
          hide-canvas
          show-swatches
          :value="item"
          mode="hexa"
          @input="colorInput"
        >
        </v-color-picker>
      </v-list-item>
    </template>
    <template v-slot:selection>
      <div class="selected-swatch" :style="selectedStyle"></div>
    </template>
  </v-select>
</template>
<script>
export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: String,
      description: 'The hex value'
    },
    label: {
      type: String,
      description: 'The label to be displayed for the component',
      default: 'Choose'
    },
    rules: {
      type: Array,
      description: 'The rules to govern the color'
    }
  },
  data() {
    return {}
  },
  computed: {
    colorRules() {
      return this.rules || []
    },
    selectedStyle() {
      if (this.value) return { 'background-color': this.value }

      return null
    },
    items() {
      return [this.value || '']
    },
    menuProperties() {
      return { maxWidth: 300 }
    }
  },
  methods: {
    colorInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.selected-swatch {
  height: 18px;
  max-height: 18px;
  width: 45px;
  margin: 2px 4px;
  border-radius: 2px;
  user-select: none;
  overflow: hidden;
}
</style>
